import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useCookies } from "react-cookie"
import HelloCard from "./hello_card"
import HelloInterstitial from "./hello_card/hello_interstitial"
import debounceMatchMedia from "../lib/debounce_match_media"

const minModalWidth = 850

export const proDetailsPopupCookieName = userId => `hide_intercept_v2_${userId}`

const ProDetailsPopup = ({
  getProUrl,
  userId,
  appletQuotaExceeded,
  eligibleForTrial,
  imgTag,
  imgTagMobile,
}) => {
  const cookieName = proDetailsPopupCookieName(userId)
  const [cookies, setCookie] = useCookies([cookieName])
  const [hideIntercept, setHideIntercept] = useState(cookies[cookieName])
  const [isDesktop, setDesktop] = useState(
    window.matchMedia(`(min-width: ${minModalWidth}px)`)?.matches
  )

  const object_id = appletQuotaExceeded
    ? "past_pro_exceded_quota"
    : "non_pro_below_quota"

  useEffect(debounceMatchMedia.bind(null, minModalWidth, setDesktop), [])

  if (hideIntercept) {
    return null
  }

  let title = eligibleForTrial ? `Try Pro for free` : "Built for creators"
  let mainBodyCopy =
    "Unlock more, better, faster Applets and the ability to create multiple actions."
  const ctaTitleCopy = eligibleForTrial ? "Try now, pay later" : "Get Pro"
  const noCreditCardCopy = eligibleForTrial ? "No credit card required." : null

  const ResponsiveGreeting = isDesktop ? HelloInterstitial : HelloCard

  return (
    <ResponsiveGreeting
      containerStyle="covering"
      ctaTitle={ctaTitleCopy}
      clickAcceptTracking={{
        object_id,
        object_type: "get_pro",
        location_type: "pro_announcemenet",
      }}
      clickAcceptUrl={getProUrl}
      clickDeclineTracking={{
        object_id,
        object_type: "maybe_later",
        location_type: "pro_announcemenet",
      }}
      onClickDecline={e => {
        e.preventDefault()
        setCookie(cookieName, true)
        setHideIntercept(true)
      }}
      declineCopy="Maybe later"
      logoHtml={isDesktop ? imgTag : imgTagMobile}
      mainTitle={title}
      mainBody={mainBodyCopy}
      noCreditCardCopy={noCreditCardCopy}
    />
  )
}

ProDetailsPopup.propTypes = {
  eligibleForTrial: PropTypes.bool,
  getProUrl: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  appletQuotaExceeded: PropTypes.bool.isRequired,
  imgTag: PropTypes.string.isRequired,
  imgTagMobile: PropTypes.string.isRequired,
}

export default ProDetailsPopup
